import { Bus, BusStop } from '@/plugins/api'
import alert from '@/plugins/alert'
import { textHelpers } from '../../helpers/TextHelper'
import { sortBy, uniq } from 'lodash'

const DOW_MAP = {
  monday: 'T2',
  tuesday: 'T3',
  wednesday: 'T4',
  thursday: 'T5',
  friday: 'T6',
  saturday: 'T7',
  sunday: 'CN'
}

const alertNoCoordinateInBusStops = (busStops = []) => {
  let noCoordDOWs = uniq(busStops.filter(bs => !bs.lat || !bs.long).map(bs => bs.busSchedule.dayOfWeek))
  if (noCoordDOWs.length) {
    const dowMapKeys = Object.keys(DOW_MAP)
    const tmp = sortBy(
      noCoordDOWs.map(dow => ({ dow: DOW_MAP[dow], i: dowMapKeys.indexOf(dow) })),
      d => d.i
    )
      .map(d => d.dow)
      .join(',')
    alert.error(`Có điểm dừng không có toạ độ trong các ngày: ${tmp}`)
  }
}

export default {
  namespaced: true,
  state: {
    busData: {},
    weekdays: {}
  },
  actions: {
    async initBus({ commit }, id) {
      let busData = await Bus.fetchOne(id)
      let busSchedules = busData.bus_schedules
      const listBusStop = await BusStop.fetch({
        bus: busData.id,
        _limit: -1
      })
      alertNoCoordinateInBusStops(listBusStop)
      busSchedules = busSchedules.map(item => {
        let busStops = listBusStop.filter(busStop => busStop.busSchedule.id === item.id)
        return { ...item, busStops }
      })
      let valueStart = null
      let weekdays = {
        monday: valueStart,
        tuesday: valueStart,
        wednesday: valueStart,
        thursday: valueStart,
        friday: valueStart,
        saturday: valueStart
      }
      busSchedules.map(item => {
        let key = textHelpers.getKeyBusSchedule(item.periodTime, item.direction)
        if (weekdays[item.dayOfWeek]) {
          let arr = weekdays[item.dayOfWeek]
          arr[key] = { ...item, key }
          weekdays[item.dayOfWeek] = arr
        } else {
          let arr = [0, 1, 2, 3]
          arr[key] = { ...item, key }
          weekdays[item.dayOfWeek] = arr
        }
      })
      commit('changeState', {
        busData,
        weekdays
      })
    },
    async fetchBus({ commit }, id) {
      commit('setBus', null)
      commit('setBus', await Bus.fetchOne(id))
    },
    async updateBus({ commit }, { id, ...params }) {
      try {
        const bus = await Bus.update(id, params)
        alert.success('Chỉnh sửa thành công!')
        commit('setBus', bus)
      } catch (e) {
        alert.error(e)
      }
    },
    async createBusStop({ state, dispatch }, { data, week }) {
      try {
        if (!week) await BusStop.create({ ...data })
        else await BusStop.addBusStopInAllDay({ ...data })
        dispatch('initBus', state.busData.id)
        alert.success('Thêm mới điểm dừng thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async updateStudentBusStop(
      { state, dispatch },
      { id, student, selectDaysOfTheWeek, address, direction, periodTime, isDefaultAbsent, defaultAbsents }
    ) {
      if (!selectDaysOfTheWeek) {
        await BusStop.addStudentInBusStop(id, { students: [student], isDefaultAbsent })
      } else {
        await BusStop.addStudentInBusStopInAllDay(id, {
          student,
          address,
          direction,
          periodTime,
          defaultAbsents
        })
      }
      dispatch('initBus', state.busData.id)
    },
    async deleteStudentBusStop({ state, dispatch }, { id, students }) {
      await BusStop.deleteStudentInBusStop(id, { students: students })
      dispatch('initBus', state.busData.id)
    },
    async updateBusStop({ state, dispatch }, { id, ...data }) {
      try {
        await BusStop.update(id, data)
        dispatch('initBus', state.busData.id)
        alert.success('Chỉnh sửa điểm dừng thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async removeBusStop({ state, dispatch }, data) {
      try {
        await BusStop.remove(data.id)
        dispatch('initBus', state.busData.id)
        alert.success('Xóa điểm dừng thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async updateBusStopOrder(_, params) {
      await BusStop.updateBusStopOrder(params)
    },
    async editStudentDefaultAbsentBusStop({ state, dispatch }, { id, ...data }) {
      await BusStop.updateDefaultAbsentForStudent(id, data)
      dispatch('initBus', state.busData.id)
    }
  },
  mutations: {
    setBus(state, busData) {
      state.busData = busData
    }
  },
  getters: {
    busData: state => {
      return state.busData
    },
    weekdays: state => {
      return state.weekdays
    }
  }
}
